module.exports = [{"name":"Togocel","prefixes":[],"requireToken":false},{"name":"Moov","prefixes":[],"requireToken":false}]


//////////////////
// WEBPACK FOOTER
// ./src/views/Request/MobileNetworks.json
// module id = 825
// module chunks = 0